export  const ItemTypes= {
    APARTMENT: 'apartment',
};